import EliminarModal from "./EliminarModal";
import { Modal } from "../Modal/index";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
  name: string;
  handleDeletion: Function;
  isLoading?: boolean
  onClose?: Function;
};

const EliminateModal = ({
  toggleModal,
  urlTittle,
  name,
  handleDeletion,
  isLoading,
  onClose
}: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={name ? name : "Eliminar Empleado"}
        titleStyle={styles}
        urlTittle={urlTittle}
        onClose={()=> onClose?.()}
      >
        <EliminarModal
          name={name}
          urlTittle={urlTittle}
          isLoading={isLoading}
          handleDeletion={() =>  handleDeletion()}
        />
      </Modal>
    </>
  );
};

export default EliminateModal;
